export default __webpack_public_path__ + "static/solidified-remains-720-b6c1f7a6002f534219704afbb1f317db.mp4";